// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.sdfY9vD0S5g8HmZxPj0R{box-sizing:border-box;width:492px;max-width:100%;overflow-x:hidden}.ojWqSP7s8A4Ndp9xR9iU{height:100%;margin-top:24px;overflow:visible}.bsHIaPE1dYk7uTZuzpwE{margin-bottom:40px}.liZky6T5qNYkAiD7FKJd{margin-bottom:8px}.MAg96q2VN3AqAUsvmFFh{padding-left:12px}.pxjHR5SyG4ADacGTLrn5{padding:12px}.jFD40RG_0TM2H1BZXqyO{margin-top:8px}.IDsf3uLxsIHrXHuWgvIQ{margin-top:24px}.xbjIYcl8GRUWMEZWqk9N{padding:11px 8px 11px 12px}.xbjIYcl8GRUWMEZWqk9N>div{white-space:nowrap;text-overflow:ellipsis;display:block;overflow:hidden}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `sdfY9vD0S5g8HmZxPj0R`,
	"einFieldContainer": `ojWqSP7s8A4Ndp9xR9iU`,
	"bannerWrap": `bsHIaPE1dYk7uTZuzpwE`,
	"numberOfCreditsInput": `liZky6T5qNYkAiD7FKJd`,
	"textInput": `MAg96q2VN3AqAUsvmFFh`,
	"selectPadding": `pxjHR5SyG4ADacGTLrn5`,
	"noEmailCheckbox": `jFD40RG_0TM2H1BZXqyO`,
	"countrySelectWrap": `IDsf3uLxsIHrXHuWgvIQ`,
	"countriesSelect": `xbjIYcl8GRUWMEZWqk9N`
};
export default ___CSS_LOADER_EXPORT___;
